<template>
  <iframe
    id="chatBoxApiSport"
    :src="urlIframe"
    width="100%"
    :height="heightContent"
    allowtransparency="true"
    allow="autoplay"
    frameborder="0"
    marginheight="0"
    marginwidth="0"
    scrolling="auto"
    ref="iframeChat"
  ></iframe>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { useIsMobile } from "~src/utils/isMobile";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import { CHATBOX_SERVICE_URL } from '~src/utils/constant';
import { usecommonStore } from "~src/stores/CommonStore"

const commonStore = usecommonStore();
const matchDetailStore = useMatchDetailStore();

const activeTab = computed(() => matchDetailStore.getActiveTab);
const isShowChat = computed(() => matchDetailStore.getIsShowChat);
const screenHeightVisualViewport = computed(() => matchDetailStore.getScreenHeightVisualViewport);
const heightContent = computed(() => matchDetailStore.getHeightContent);
const heightPlayer = computed(() => matchDetailStore.getHeightPlayer);
const playActiveTab = computed(() => matchDetailStore.getPlayActiveTab);
const isChatTyping = computed(() => matchDetailStore.getIsChatTyping);
const isMobile = ref(useIsMobile());

const urlIframe = `${CHATBOX_SERVICE_URL}/room/6362206e7e42f3850b75692c/${commonStore.getSportType}/${isMobile.value ? 'mobile' : 'desktop'}`;

onMounted(async () => {
  const getHeightContent = (heightPlayerValue: number) => {
    // @ts-ignore
    const screenHeight = playActiveTab.value === 'player' ? window.visualViewport.height : window.innerHeight;

    return activeTab.value === "chat" && !isShowChat.value ? 35 : screenHeight - heightPlayerValue - 45 - 10;
  }

  const _ = this;
  window.addEventListener(
    "message",
    function (e) {
      if (e.origin !== CHATBOX_SERVICE_URL) return;

      if (e.data.height === 35) {
        matchDetailStore.setIsShowChat(false);
      } else {
        matchDetailStore.setIsShowChat(true);
      }

      const elementPlayer: any = document.getElementById('embed-player');
      if(isMobile.value && elementPlayer) {
        if(isChatTyping.value && e.data.focus_auth === true) {
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
          window.scrollTo({
            top: 0,
            behavior: 'smooth' // Cuộn mượt mà
          });
        }

        if(e.data.isPopup !== undefined || e.data.focus_typing === true) {
          const elementsHide: any = document.querySelectorAll(".as-hide-popup-chat");
          const elementsRemoveMargin: any = document.querySelectorAll(".as-remove-margin");
          const elementsRemoveMarginVertical: any = document.querySelectorAll(".as-remove-margin-vertical");
          const elementsRemoveMarginHorizontal: any = document.querySelectorAll(".as-remove-margin-horizontal");
          const elementMain : any = document.querySelector(".main");
          const elementContentPage : any = document.querySelector(".content_page");
          const elementPlayMain: any = document.querySelector('#play_main');
          const elementPlayMainLeft: any = document.querySelector('.play_main_left');
          const elementPlayMainRight: any = document.querySelector('.play_main_right');
          const elementPlayTab: any = document.querySelector('#play_tab');
          const elementPlayTabButtons: any = document.querySelectorAll('#play_tab button');
          const elementLivePlayerContent: any = document.querySelector('#live-player-content');
          const elementIframeChat: any = document.getElementById('chatBoxApiSport');
          const elementDetailContent: any = document.getElementById('as-match-detail-content');

          if(e.data.isPopup === true || e.data.focus_typing === true) {
            if(playActiveTab.value === 'player') {
              elementPlayMainLeft.scrollIntoView({
                behavior: "smooth", // "smooth" để cuộn mượt mà, "auto" để cuộn ngay lập tức
                block: "start",    // "start", "center", "end" hoặc "nearest"
              });
            }

            setTimeout(() => {
              elementsHide.forEach((element: any) => {
                element.style.setProperty("display", "none", "important");
              });
              elementsRemoveMargin.forEach((element: any) => {
                element.style.setProperty("padding", "0px", "important");
                element.style.setProperty("margin", "0px", "important");
              });
              elementsRemoveMarginVertical.forEach((element: any) => {
                element.style.setProperty("padding-top", "0px", "important");
                element.style.setProperty("padding-bottom", "0px", "important");
                element.style.setProperty("margin-top", "0px", "important");
                element.style.setProperty("margin-bottom", "0px", "important");
              });
              elementsRemoveMarginHorizontal.forEach((element: any) => {
                element.style.setProperty("padding-left", "0px", "important");
                element.style.setProperty("padding-right", "0px", "important");
                element.style.setProperty("margin-left", "0px", "important");
                element.style.setProperty("margin-right", "0px", "important");
              });
              if(elementMain) {
                elementMain.style.setProperty("padding-top", "0px", "important");
                elementMain.style.setProperty("padding-bottom", "0px", "important");
                elementMain.style.transform = 'translateY(0)';
              }
              if(elementContentPage) {
                elementContentPage.style.paddingTop = '0px';
              }
              if(elementPlayMain) {
                if(!elementPlayTab) {
                  elementPlayMain.style.paddingBottom = '0';
                }
                elementPlayMain.style.gap = '0px';
              }
              if(elementPlayMainRight) {
                elementPlayMainRight.style.marginTop = '6px';
              }
              if(elementPlayTab) {
                elementPlayTabButtons.forEach((element: any) => {
                  element.style.setProperty("padding", "0", "important");
                });
              }
              if(elementLivePlayerContent) {
                elementLivePlayerContent.style.setProperty("padding", "0px", "important");
                elementLivePlayerContent.style.setProperty("border", "none", "important");
              }
              document.body.style.setProperty("padding-top", "0px", "important");

              // @ts-ignore
              const heightPlayerValue = elementPlayMainLeft.offsetHeight;
              const heightContentResize = getHeightContent(heightPlayerValue);
              elementDetailContent.style.height = `${heightContentResize}px`;
              elementIframeChat.style.height = `${heightContentResize}px`;
              matchDetailStore.setHeightPlayer(heightPlayerValue);

              if(playActiveTab.value === 'player') {
                // Thử cuộn trang lên đầu
                window.scrollTo(0, 0);
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
                // Thử cuộn phần tử vào tầm nhìn
                elementPlayMainLeft.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }

              matchDetailStore.setIsChatTyping(true);
            }, 300);
          } else if(e.data.isPopup === false) {
            elementsHide.forEach((element: any) => {
              element.style.removeProperty('display');
            });
            elementsRemoveMargin.forEach((element: any) => {
              element.style.removeProperty('padding');
              element.style.removeProperty('margin');
            });
            elementsRemoveMarginVertical.forEach((element: any) => {
              element.style.removeProperty('padding-top');
              element.style.removeProperty('padding-bottom');
              element.style.removeProperty('margin-top');
              element.style.removeProperty('padding-bottom');
            });
            elementsRemoveMarginHorizontal.forEach((element: any) => {
              element.style.removeProperty('padding-left');
              element.style.removeProperty('padding-right');
              element.style.removeProperty('margin-left');
              element.style.removeProperty('padding-right');
            });
            if(elementMain) {
              elementMain.style.removeProperty('padding-top');
              elementMain.style.removeProperty('padding-bottom');
              elementMain.style.removeProperty('transform');
            }
            if(elementContentPage) {
              elementContentPage.style.removeProperty('padding-top');
            }
            if(elementPlayMain) {
              elementPlayMain.style.removeProperty('position');
              elementPlayMain.style.removeProperty('padding-bottom');
              elementPlayMain.style.removeProperty('gap');
            }
            if(elementPlayMainRight) {
              elementPlayMainRight.style.marginTop = '0px';
            }
            if(elementPlayTab) {
              elementPlayTabButtons.forEach((element: any) => {
                element.style.setProperty("padding", "0", "important");
              });
            }
            if(elementLivePlayerContent) {
              elementLivePlayerContent.style.removeProperty("padding");
              elementLivePlayerContent.style.removeProperty("border");
            }
            document.body.style.removeProperty('padding-top');

            matchDetailStore.setIsChatTyping(false);

            setTimeout(() => {
              elementDetailContent.style.height = `${heightContent.value}px`;
              elementIframeChat.style.height = `${heightContent.value}px`;
            }, 300);

            setTimeout(() => {
              const rect = elementPlayer.getBoundingClientRect(); // Lấy tọa độ của phần tử
              const offsetTop = rect.top + window.pageYOffset; // Tọa độ Y tính từ đầu trang

              // Cuộn đến vị trí elment player
              window.scrollTo({
                top: offsetTop - 56,
                behavior: "smooth", // Cuộn mượt (có thể thay bằng "auto")
              });
            }, 500);
          }
        }
      }
    },
    false
  );

  // @ts-ignore
  window.visualViewport.addEventListener("resize", () => {
    if (isMobile.value && isChatTyping.value) {
      setTimeout(() => {
        const elementPlayMainLeft: any = document.querySelector('.play_main_left');
        const elementIframeChat: any = document.getElementById('chatBoxApiSport');
        const elementDetailContent: any = document.getElementById('as-match-detail-content');

        const heightContentResize = getHeightContent(heightPlayer.value);
        elementDetailContent.style.height = `${heightContentResize}px`;
        elementIframeChat.style.height = `${heightContentResize}px`;

        // @ts-ignore
        const screenHeight = window.visualViewport.height;

        // nếu là màn player và có thay đổi visualViewport lớn hơn 200px thì mới scroll lên đầu
        // trường hợp viewboard hiển thị lên hoặc ẩn đi thì mới scroll lên đầu
        if(playActiveTab.value === 'player' && (screenHeightVisualViewport.value > screenHeight + 200 || screenHeightVisualViewport.value + 200 < screenHeight)) {
          // Thử cuộn trang lên đầu
          window.scrollTo(0, 0);
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
          // Thử cuộn phần tử vào tầm nhìn
          elementPlayMainLeft.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        matchDetailStore.setScreenHeightVisualViewport(screenHeight);
      }, 300);
    }
  });

  // khi chuyển đổi giữa tab playe và simulation thì thay đổi lại height của heightPlayer
  const changeHeightPlayer = () => {
    if (isMobile.value && isChatTyping.value) {
      const elementPlayMainLeft: any = document.querySelector('.play_main_left');
      const elementIframeChat: any = document.getElementById('chatBoxApiSport');
      const elementDetailContent: any = document.getElementById('as-match-detail-content');
      const heightPlayerValue = elementPlayMainLeft.offsetHeight;
      const heightContentResize = getHeightContent(heightPlayerValue);
      elementDetailContent.style.height = `${heightContentResize}px`;
      elementIframeChat.style.height = `${heightContentResize}px`;
      matchDetailStore.setHeightPlayer(heightPlayerValue);
    }
  }
  const btnLivePlayerTabTabElement:any = document.getElementById('live-player-tab');
  const btnSimulationTabElement:any = document.getElementById('simulation-tab');
  if(btnLivePlayerTabTabElement) {
    btnLivePlayerTabTabElement.addEventListener('click', function() {
      matchDetailStore.setPlayActiveTab('player');
      changeHeightPlayer();
    });
  }
  if(btnSimulationTabElement) {
    btnSimulationTabElement.addEventListener('click', function() {
      matchDetailStore.setPlayActiveTab('simulation');
      changeHeightPlayer();
    });
  }
});

// const iframeChat = ref<HTMLElement | null>(null);
// const clickOutside = () => {};
// useClickOutside([iframeChat], {
//   handler: clickOutside,
//   middleware: (event) => {
//     return true;
//   },
// });
</script>

<script lang="ts">
export default {};
</script>
